module.exports = __webpack_public_path__ + "static/media/escrever-en.a6e4ea95.svg";